<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="box-offset" v-else>
            <div class="box-ttl-wrap">
                <div class="box-ttl">
                    Notifications
                </div>
            </div>
            <div class="form mt-3">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-holder table-responsive ">
                            <table class="table shifts-table">
                                <thead>
                                <tr>
                                    <th>Notification</th>
                                    <th class="text-center">Text</th>
                                    <th class="text-center">Email</th>
                                    <th class="text-center">On Platform</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="item in listOfNotifications"
                                    :key="item.id"
                                >
                                    <td>{{item.notification_item.script}}</td>
                                    <td class="text-center">
                                        <div class="centred-checkbox">
                                            <div class="form-group form-group-1">
                                                <div class="form-check">
                                                    <input
                                                        class="form-check-input-checkbox"
                                                        type="checkbox"
                                                        id="home-office"
                                                        v-model="item.byText"
                                                    >
                                                    <label class="form-check-label" for="home-office"></label>
                                                </div>
                                            </div>
                                        </div>

                                    </td>
                                    <td class="text-center">
                                        <div class="centred-checkbox">
                                            <div class="form-group form-group-1">
                                                <div class="form-check">
                                                    <input
                                                        class="form-check-input-checkbox"
                                                        type="checkbox"
                                                        id="home-office"
                                                        v-model="item.byEmail"
                                                    >
                                                    <label class="form-check-label" for="home-office"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="centred-checkbox">
                                            <div class="form-group form-group-1">
                                                <div class="form-check">
                                                    <input
                                                        class="form-check-input-checkbox"
                                                        type="checkbox"
                                                        id="home-office"
                                                        v-model="item.onPlatform"
                                                    >
                                                    <label class="form-check-label" for="home-office"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns-wrap mt-4">
                <button  class="btn btn--outline-primary w-100 w-sm-auto"
                         @click="reloadPage">Cancel
                </button>
                <button
                    class="btn btn--secondary w-100 w-sm-auto"
                    @click="updateListOfNotifications"
                >Save</button>
            </div>
        </div>
    </div>

</template>

<script>
import UsersServices from "../services/UsersServices";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'Notifications',
    mixins: [ModalHandler],
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            listOfNotifications: [],
        }
    },
    methods: {
        async getListOfUserNotifications() {
            try {
                const {data: response} = await UsersServices.getListOfNotifications(this.id)
                this.listOfNotifications = response
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        async updateListOfNotifications() {
            this.$showLoadingMessage()
            try {
                await UsersServices.updateNotifications(this.id, this.listOfNotifications)
                this.$showSuccessMessage('The list of notifications has been updated')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The list of notifications was not updated. Please try again')
            }
        }
    },
    mounted() {
        this.getListOfUserNotifications()
    }
}

</script>



<style scoped>

</style>
